import { TradingCampaignRules } from "@cede/types";
import { getCurrentOrStartingEpoch } from "./core";
import { CampaignSummaryWithStats } from "@/components/features/campaigns/types";
import Decimal from "decimal.js";

export const getTargetVolume = (campaign: CampaignSummaryWithStats): number | null => {
  try {
    const currentEpoch = getCurrentOrStartingEpoch(campaign);
    if (!currentEpoch?.rule) return null;

    const { rule, data } = currentEpoch.rule;

    switch (rule) {
      case TradingCampaignRules.PROPORTIONAL_V2: {
        // Global volume limit for proportional rewards
        const proportionalData = data;
        return proportionalData?.maxTotalVolumeByEpoch || null;
      }

      case TradingCampaignRules.FIXED_PER_VOLUME: {
        // FCFS: requiredVolume × available spots
        const requiredVolume = data.requiredVolume || new Decimal(0);
        const limit = data.limit;
        return requiredVolume && limit ? requiredVolume.mul(limit).toNumber() : null;
      }

      case TradingCampaignRules.PVP: {
        // First phase volume limit
        return data?.phases?.[0]?.maxVolume || null;
      }

      case TradingCampaignRules.PRIZE_BY_SLOT:
      case TradingCampaignRules.STAIRS:
      case TradingCampaignRules.PROPORTIONAL:
      case TradingCampaignRules.CUSTOM:
      case TradingCampaignRules.SPREAD_TRADES_OVER_TIME:
        // No limit for other rules
        return null;

      default:
        return null;
    }
  } catch {
    // Return null if any error occurs during volume calculation
    return null;
  }
};
